var moduleMap = {
	"./MainLayout": () => {
		return Promise.all([__webpack_require__.e(1838), __webpack_require__.e(9876), __webpack_require__.e(5440), __webpack_require__.e(1776), __webpack_require__.e(2469), __webpack_require__.e(8556), __webpack_require__.e(56), __webpack_require__.e(4092), __webpack_require__.e(9642), __webpack_require__.e(7366), __webpack_require__.e(4914), __webpack_require__.e(6672), __webpack_require__.e(3444), __webpack_require__.e(9314), __webpack_require__.e(7972), __webpack_require__.e(3720), __webpack_require__.e(6495)]).then(() => (() => ((__webpack_require__(73958)))));
	},
	"./ErrorBoundary": () => {
		return Promise.all([__webpack_require__.e(1838), __webpack_require__.e(9876), __webpack_require__.e(1776), __webpack_require__.e(8556), __webpack_require__.e(4914), __webpack_require__.e(6672), __webpack_require__.e(3444), __webpack_require__.e(532)]).then(() => (() => ((__webpack_require__(52192)))));
	},
	"./TimeConnected": () => {
		return Promise.all([__webpack_require__.e(4914), __webpack_require__.e(9314), __webpack_require__.e(1878)]).then(() => (() => ((__webpack_require__(91878)))));
	},
	"./AppMultiSelect": () => {
		return Promise.all([__webpack_require__.e(1838), __webpack_require__.e(9876), __webpack_require__.e(5440), __webpack_require__.e(2469), __webpack_require__.e(8556), __webpack_require__.e(56), __webpack_require__.e(9642), __webpack_require__.e(112), __webpack_require__.e(4611), __webpack_require__.e(4914), __webpack_require__.e(6672), __webpack_require__.e(3444), __webpack_require__.e(3592)]).then(() => (() => ((__webpack_require__(73592)))));
	},
	"./NotAuthorized": () => {
		return Promise.all([__webpack_require__.e(1838), __webpack_require__.e(9876), __webpack_require__.e(8556), __webpack_require__.e(4914), __webpack_require__.e(6672), __webpack_require__.e(5014)]).then(() => (() => ((__webpack_require__(45402)))));
	},
	"./AppSelect": () => {
		return Promise.all([__webpack_require__.e(1838), __webpack_require__.e(9876), __webpack_require__.e(5440), __webpack_require__.e(2469), __webpack_require__.e(8556), __webpack_require__.e(56), __webpack_require__.e(9642), __webpack_require__.e(112), __webpack_require__.e(4611), __webpack_require__.e(4914), __webpack_require__.e(6672), __webpack_require__.e(3444), __webpack_require__.e(7487)]).then(() => (() => ((__webpack_require__(7487)))));
	},
	"./AppInput": () => {
		return Promise.all([__webpack_require__.e(1838), __webpack_require__.e(9876), __webpack_require__.e(5440), __webpack_require__.e(1776), __webpack_require__.e(2469), __webpack_require__.e(4092), __webpack_require__.e(4914), __webpack_require__.e(6672), __webpack_require__.e(3444), __webpack_require__.e(9238)]).then(() => (() => ((__webpack_require__(89499)))));
	},
	"./AppTextArea": () => {
		return Promise.all([__webpack_require__.e(1838), __webpack_require__.e(9876), __webpack_require__.e(5440), __webpack_require__.e(1776), __webpack_require__.e(2469), __webpack_require__.e(4092), __webpack_require__.e(4914), __webpack_require__.e(6672), __webpack_require__.e(3444), __webpack_require__.e(5088)]).then(() => (() => ((__webpack_require__(25893)))));
	},
	"./AppCustomCheckbox": () => {
		return Promise.all([__webpack_require__.e(4914), __webpack_require__.e(8275)]).then(() => (() => ((__webpack_require__(68275)))));
	},
	"./AppButton": () => {
		return Promise.all([__webpack_require__.e(1838), __webpack_require__.e(9876), __webpack_require__.e(1776), __webpack_require__.e(4914), __webpack_require__.e(6672), __webpack_require__.e(3444), __webpack_require__.e(9553)]).then(() => (() => ((__webpack_require__(37143)))));
	},
	"./ManageSideDrawer": () => {
		return Promise.all([__webpack_require__.e(1838), __webpack_require__.e(9876), __webpack_require__.e(5440), __webpack_require__.e(1776), __webpack_require__.e(9402), __webpack_require__.e(4914), __webpack_require__.e(6672), __webpack_require__.e(3444), __webpack_require__.e(7972), __webpack_require__.e(6799)]).then(() => (() => ((__webpack_require__(46799)))));
	},
	"./RecordTotalCount": () => {
		return Promise.all([__webpack_require__.e(4914), __webpack_require__.e(3444), __webpack_require__.e(940)]).then(() => (() => ((__webpack_require__(10940)))));
	},
	"./AppPagination": () => {
		return Promise.all([__webpack_require__.e(1838), __webpack_require__.e(9876), __webpack_require__.e(5440), __webpack_require__.e(2469), __webpack_require__.e(56), __webpack_require__.e(112), __webpack_require__.e(8188), __webpack_require__.e(4914), __webpack_require__.e(6672), __webpack_require__.e(3444), __webpack_require__.e(5117)]).then(() => (() => ((__webpack_require__(5117)))));
	},
	"./EnvironmentVariables": () => {
		return __webpack_require__.e(1125).then(() => (() => ((__webpack_require__(21125)))));
	},
	"./Types": () => {
		return __webpack_require__.e(3748).then(() => (() => ((__webpack_require__(73748)))));
	},
	"./IndexStyle": () => {
		return __webpack_require__.e(662).then(() => (() => ((__webpack_require__(50662)))));
	},
	"./LayoutStyle": () => {
		return __webpack_require__.e(4222).then(() => (() => ((__webpack_require__(24222)))));
	},
	"./OverrideStyle": () => {
		return __webpack_require__.e(6064).then(() => (() => ((__webpack_require__(26064)))));
	},
	"./IconSvg": () => {
		return Promise.all([__webpack_require__.e(4914), __webpack_require__.e(518)]).then(() => (() => ((__webpack_require__(50518)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});